<template>
  <!-- 按行业找律师 -->
  <div class="hangye">
    <div class="hangyebanner">
      <img src="~assets/findlawchild/hangyebanner.png" alt="" />
    </div>
    <div class="hangyelist flex_start wrap">
      <div class="hangyeitem" 
      v-for="item in hylist" 
      :key="item.id"
      @click="tojump(item.id)"
      >{{item.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      hylist:[]
    }
  },
  beforeMount(){
    this.gethangye()
  },
  methods:{
    gethangye(){
      this.$http.fdlaw.getMajorIfy()
        .then((res) => {
          this.hylist = res.data
        }).catch((err) => {
          console.log('err',err);
        });
    },
    tojump(id){
	  this.$router.push({name:'lslist',params:{tradeid:id}});
    }
  }
};
</script>

<style lang="scss" scoped>
.hangye {
  background-color: #fff;
  .hangyebanner {
    max-width: 1920px;
    width: 100%;
    overflow: hidden;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .hangyelist {
    width: 1200px;
    padding: 50px 0 20px;
    margin: 0 auto;

    .hangyeitem {
      cursor: pointer;
      width: 270px;
      height: 160px;
      border-radius: 10px;
      margin-bottom: 30px;
      margin-right: 30px;
      padding: 60px 30px;
      position: relative;
      &:hover {
        color: #0465ea;
        &::after {
          background: #0465ea;
        }
      }
      &::after {
        content: "";
        position: absolute;
        top: 95px;
        left: 30px;
        width: 22px;
        height: 3px;
        background: #b8b8b8;
      }
      &:nth-child(1n + 0) {
        background: url("~assets/findlawchild/xxitem_bg1.png");
      }
      &:nth-child(2n + 0) {
        background: url("~assets/findlawchild/xxitem_bg2.png");
      }
      &:nth-child(3n + 0) {
        background: url("~assets/findlawchild/xxitem_bg3.png");
      }
      &:nth-child(4n + 0) {
        background: url("~assets/findlawchild/xxitem_bg4.png");
      }
      &:nth-child(5n + 0) {
        background: url("~assets/findlawchild/xxitem_bg5.png");
      }
      &:nth-child(6n + 0) {
        background: url("~assets/findlawchild/xxitem_bg6.png");
      }
      &:nth-child(7n + 0) {
        background: url("~assets/findlawchild/xxitem_bg7.png");
      }
      &:nth-child(8n + 0) {
        background: url("~assets/findlawchild/xxitem_bg8.png");
      }
    }
  }
}
</style>